import styled from 'styled-components';

export const MainContentWrapper = styled.div`
    text-align: center;
`

export default MainContentWrapper;